// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Grid */
.people-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 0.75rem;
}

/* Card shell */
.person-card {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--bs-border-color, #d0d7de);
  border-radius: 0.35rem;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease;
  overflow: hidden;
}

.person-card:hover {
  border-color: var(--sms-blue-light, #4a82bb);
  box-shadow: 0 2px 10px rgba(52, 100, 152, 0.12);
  transform: translateY(-1px);
}

.person-card:active {
  transform: translateY(0);
  box-shadow: none;
}

/* Header band */
.person-card__header {
  padding: 0.55rem 0.75rem 0.45rem;
  background: var(--sms-gray-light, #f4f4f4);
  border-bottom: 1px solid var(--bs-border-color, #d0d7de);
}

.person-card__name {
  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: var(--sms-blue, #346498);
  line-height: 1.2;
}

/* Body */
.person-card__body {
  flex: 1;
  padding: 0.6rem 0.75rem 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* Attribute row */
.person-card__attr-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem 1rem;
}

.person-card__attr {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.person-card__attr-label {
  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--sms-gray-mid, #888);
}

.person-card__attr-value {
  font-size: 0.85rem;
  color: #2c2c2c;
}

/* Registration ID pills */
.person-card__ids {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.person-card__id-badge {
  display: inline-flex;
  align-items: baseline;
  gap: 0.2rem;
  padding: 0.15rem 0.45rem;
  border: 1px solid var(--bs-border-color, #d0d7de);
  border-radius: 1rem;
  font-size: 0.75rem;
  color: #2c2c2c;
  background: #fff;
  white-space: nowrap;
}

.person-card__id-org {
  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);
  font-weight: 700;
  font-size: 0.62rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--sms-gray-mid, #888);
}

/* Footer */
.person-card__footer {
  padding: 0.5rem 0.75rem;
  border-top: 1px solid var(--bs-border-color, #d0d7de);
  display: flex;
  justify-content: flex-end;
  background: #fafafa;
}

.person-card__select-btn {
  font-family: var(--sms-font-ui, 'Barlow', sans-serif);
  font-size: 0.78rem;
  letter-spacing: 0.05em;
}

/* Accessibility: keyboard focus */
.person-card:focus-visible {
  outline: 2px solid var(--sms-blue, #346498);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/people/list-user-people/list-user-people.component.css"],"names":[],"mappings":"AAAA,SAAS;AACT;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,iDAAiD;EACjD,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,+EAA+E;EAC/E,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,gCAAgC;EAChC,0CAA0C;EAC1C,wDAAwD;AAC1D;;AAEA;EACE,oEAAoE;EACpE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,OAAO;EACP,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oEAAoE;EACpE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,WAAW;EACX,wBAAwB;EACxB,iDAAiD;EACjD,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oEAAoE;EACpE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,WAAW;AACX;EACE,uBAAuB;EACvB,qDAAqD;EACrD,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,2CAA2C;EAC3C,mBAAmB;AACrB","sourcesContent":["/* Grid */\n.people-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  gap: 0.75rem;\n}\n\n/* Card shell */\n.person-card {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--bs-border-color, #d0d7de);\n  border-radius: 0.35rem;\n  background: #fff;\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease;\n  overflow: hidden;\n}\n\n.person-card:hover {\n  border-color: var(--sms-blue-light, #4a82bb);\n  box-shadow: 0 2px 10px rgba(52, 100, 152, 0.12);\n  transform: translateY(-1px);\n}\n\n.person-card:active {\n  transform: translateY(0);\n  box-shadow: none;\n}\n\n/* Header band */\n.person-card__header {\n  padding: 0.55rem 0.75rem 0.45rem;\n  background: var(--sms-gray-light, #f4f4f4);\n  border-bottom: 1px solid var(--bs-border-color, #d0d7de);\n}\n\n.person-card__name {\n  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);\n  font-weight: 700;\n  font-size: 1rem;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: var(--sms-blue, #346498);\n  line-height: 1.2;\n}\n\n/* Body */\n.person-card__body {\n  flex: 1;\n  padding: 0.6rem 0.75rem 0.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n/* Attribute row */\n.person-card__attr-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.6rem 1rem;\n}\n\n.person-card__attr {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.2;\n}\n\n.person-card__attr-label {\n  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--sms-gray-mid, #888);\n}\n\n.person-card__attr-value {\n  font-size: 0.85rem;\n  color: #2c2c2c;\n}\n\n/* Registration ID pills */\n.person-card__ids {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n}\n\n.person-card__id-badge {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 0.2rem;\n  padding: 0.15rem 0.45rem;\n  border: 1px solid var(--bs-border-color, #d0d7de);\n  border-radius: 1rem;\n  font-size: 0.75rem;\n  color: #2c2c2c;\n  background: #fff;\n  white-space: nowrap;\n}\n\n.person-card__id-org {\n  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);\n  font-weight: 700;\n  font-size: 0.62rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--sms-gray-mid, #888);\n}\n\n/* Footer */\n.person-card__footer {\n  padding: 0.5rem 0.75rem;\n  border-top: 1px solid var(--bs-border-color, #d0d7de);\n  display: flex;\n  justify-content: flex-end;\n  background: #fafafa;\n}\n\n.person-card__select-btn {\n  font-family: var(--sms-font-ui, 'Barlow', sans-serif);\n  font-size: 0.78rem;\n  letter-spacing: 0.05em;\n}\n\n/* Accessibility: keyboard focus */\n.person-card:focus-visible {\n  outline: 2px solid var(--sms-blue, #346498);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
